import { normalizeVector, sanitizeVector } from 'leva/plugin'
import type { InternalBounce, InternalBounceSettings, BounceInput } from '../types/bounce-types'
import { defaultElasticElasticity, defaultElasticGravity, defaultElasticHang, defaultElasticVelocity, defaultDecayX, defaultDecayY, defaultElasticVelocityMax, defaultElasticVelocityMin, defaultElasticGravityMax, defaultElasticGravityMin, defaultElasticElasticityMax, defaultElasticElasticityMin, defaultElasticDecayMaxX, defaultElasticDecayMaxY, defaultElasticDecayMinY, defaultElasticDecayMinX } from '../assets/constants'


const defaultElasticitySettings = { min: defaultElasticElasticityMin, max: defaultElasticElasticityMax, step: 1 }
const defaultGravitySettings = { min: defaultElasticGravityMin, max: defaultElasticGravityMax, step: 1 }
const defaultHangSettings = { min: 1, max: 200, step: 1 }
const defaultVelocitySettings = { min: defaultElasticVelocityMin, max: defaultElasticVelocityMax, step: 1 }
const defaultValue = { elasticity: defaultElasticElasticity, gravity: defaultElasticGravity, decayX:defaultDecayX, decayY: defaultDecayY, hang: defaultElasticHang, velocity: defaultElasticVelocity }
const decayXSettings = { min: defaultElasticDecayMinX, max: defaultElasticDecayMaxX, step: 1 }
const decayYSettings = { min: defaultElasticDecayMinY, max: defaultElasticDecayMaxY, step: 1 }
export const normalize = (input: BounceInput = {}) => {
  const { value: _value, ..._settings } = 'value' in input ? input : { value: input }
  const mergedSettings = {
    elasticity: { ...defaultElasticitySettings, ..._settings.elasticity },
    gravity: { ...defaultGravitySettings, ..._settings.gravity },
    decayX: { ...decayXSettings, ..._settings.decayX},
    decayY: { ...decayYSettings, ..._settings.decayY},
    hang: { ...defaultHangSettings, ..._settings.hang },
    velocity: { ...defaultVelocitySettings, ..._settings.velocity },
  }
  
  const { value, settings } = normalizeVector({ ...defaultValue, ..._value }, mergedSettings)
  return { value, settings: settings as InternalBounceSettings }
}

export const sanitize = (value: InternalBounce, settings: InternalBounceSettings, prevValue?: any) =>
  // @ts-ignore
  sanitizeVector(value, settings, prevValue)